import { authorizedTokenFromJSON, AuthorizedTokenRecord, IAuthorizedTokenData } from "common/records/AuthorizedToken";
import { TokenKind } from "common/records/Token";
import { Map, Record } from "immutable";

export const authorizedTokensFromJSON = (json: Partial<IAuthorizedTokensData>): AuthorizedTokensRecord => {
  const record: IAuthorizedTokensRecord = { ...(json as any) };

  record.byKind = Map(
    Object.entries(record.byKind || {}).map(([key, value]) => [
      key as TokenKind,
      authorizedTokenFromJSON(value as any as IAuthorizedTokenData),
    ]),
  );

  return new AuthorizedTokensRecord(record);
};

export interface IAuthorizedTokensData {
  byKind: { [key: string]: IAuthorizedTokenData };
  loading: boolean;
}

export interface IAuthorizedTokensRecord {
  byKind: Map<TokenKind, AuthorizedTokenRecord>;
  loading: boolean;
}

export const defaultAuthorizedTokensRecord: IAuthorizedTokensRecord = {
  byKind: Map<TokenKind, AuthorizedTokenRecord>(),
  loading: false,
};

export class AuthorizedTokensRecord
  extends Record<IAuthorizedTokensRecord>(defaultAuthorizedTokensRecord)
  implements IAuthorizedTokensRecord {}
